'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

export const MAX_DISPLAYED_OPEN_PAYMENTS_COUNT = 9;

interface HeaderOpenPaymentsBadgeProps {
  count: number;
}

export function HeaderOpenPaymentsBadge({ count }: HeaderOpenPaymentsBadgeProps) {
  if (count <= 0) {
    return null;
  }

  return (
    <span
      aria-hidden="true"
      className="pointer-events-none relative -ml-3 inline-flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-warning-200 px-1 text-xs font-bold text-warning-800"
      data-testid={DataTestIdEnum.OPEN_PAYMENTS_HEADER_BADGE}
    >
      {count > MAX_DISPLAYED_OPEN_PAYMENTS_COUNT ? `+${MAX_DISPLAYED_OPEN_PAYMENTS_COUNT}` : count}
    </span>
  );
}
